import card1 from "../assets/IMG_4256.jpg";
import card2 from "../assets/IMG_4420.jpg";
import card3 from "../assets/IMG_4494.jpg";
import card4 from "../assets/IMG_4526.jpg";
import egg1 from "../assets/egg_1.jpg";
import egg2 from "../assets/egg_2.jpg";
import egg3 from "../assets/egg_3.jpg";
import egg4 from "../assets/egg_4.jpg";
import card11 from "../assets/1_loved_recipe.jpg";
import card21 from "../assets/2_loved.jpg";
import card31 from "../assets/3_loved.jpg";
import card41 from "../assets/4_loved.jpg";
export const recipes = [
    {
  slug: "aloo-corn-cheese-momo",
  title: "Aloo Corn Cheese Momo",
  image: card1,

  meta: {
    servings: "2",
    prepTime: "20 min",
    cookTime: "15 min",
  },

  ingredients: {
    "Dough": [
      "¾ cup whole wheat flour",
      "2 tbsp glutinous rice flour (optional)",
      "Salt to taste",
      "1 tsp oil",
      "2 tbsp roasted beetroot purée (optional)",
      "⅓ cup water (as needed)",
    ],

    "Filling": [
      "1 boiled potato",
      "¼ cup paneer, grated",
      "1 cube processed cheese, grated",
      "1 tbsp cream cheese",
      "1 green chilli, chopped",
      "¼ cup sweet corn, boiled",
      "Salt & pepper to taste",
      "½ tsp garlic powder",
      "½ tsp onion powder",
    ],

    "Dipping Sauce": [
      "1 tbsp chilli oil",
      "2 tbsp soy sauce",
      "1 tbsp lemon juice or vinegar",
      "½ tbsp honey",
      "½ tbsp roasted sesame seeds",
      "Salt to taste",
    ],
  },

  instructions: [
    "Mix dough ingredients and knead till smooth. Rest 20 minutes.",
    "Mash potato with paneer, cheeses, chilli, corn and spices.",
    "Roll dough thin and cut into circles.",
    "Fill, pleat and seal momos.",
    "Pan-fry momos until bottoms are golden.",
    "Add water, cover and steam until cooked.",
    "Remove lid and crisp slightly.",
    "Mix dipping sauce ingredients.",
    "Serve hot momos with sauce.",
  ],
},
  
 {
    slug: "paneer-avocado-pea-paratha",
    title: "Paneer Avocado Pea Paratha",
    image: card2,

    meta: {
      servings: "6 pieces",
      prepTime: "20 min",
      cookTime: "10 min",
    },

    ingredients: {
      "Spring Onion Pea Avocado Mash": [
        "½ cup green peas, boiled",
        "1 avocado",
        "1 onion, chopped",
        "1 jalapeño, chopped",
        "1 spring onion, chopped",
        "1 green chilli, chopped",
        "Juice of ½ lemon",
        "Salt to taste",
      ],

      "Paneer Filling": [
        "200 g paneer, grated",
        "Salt and pepper to taste",
        "½ tsp onion powder",
        "½ tsp garlic powder",
        "1 tsp red chilli flakes",
        "1 tsp chaat masala",
        "1 spring onion, chopped",
      ],

      "More": [
        "Whole wheat dough (leftover or fresh)",
        "Ghee, to cook the paratha",
      ],
    },

    instructions: [
      "Boil peas till tender but bright green. Cool slightly.",
      "Mash peas with avocado using a fork or processor.",
      "Add onion, spring onion, jalapeño, chilli, lemon juice and salt. Mix well.",
      "Mix paneer with spices, spring onion, salt and pepper.",
      "Divide dough into portions. Fill with paneer mixture and seal.",
      "Roll gently into mini parathas.",
      "Cook on low–medium heat with ghee until golden on both sides.",
      "Top hot parathas with pea & spring onion mash, finish with sev if desired.",
      "Serve immediately and enjoy.",
    ],
  },
  {
  slug: "blueberry-mochi-doughnuts",
  title: "Blueberry Mochi Doughnuts",
  image: card3,

  meta: {
    servings: "8 doughnuts",
    prepTime: "15 min",
    cookTime: "15 min",
  },

  ingredients: {
    "Mochi Dough": [
      "¾ cup (120 g) glutinous rice flour",
      "2 tbsp tapioca starch",
      "2 tbsp all purpose flour",
      "¼ cup sugar",
      "1 tsp baking powder",
      "Pinch of salt",
      "⅓ cup milk",
      "1 tbsp butter",
      "2 tbsp thick yogurt",
      "½ tsp vanilla extract",
    ],

    "Blueberry Glaze": [
      "½ cup frozen blueberries",
      "Juice of ½ lime",
      "1 tbsp sugar",
      "½–¾ cup icing sugar (adjust to consistency)",
    ],
  },

  instructions: [
    "Mix all dry ingredients in a bowl.",
    "Heat milk and butter until butter melts (do not boil).",
    "Pour hot mixture into dry ingredients, add yogurt and vanilla.",
    "Knead till smooth, slightly warm and clay-like.",
    "Divide dough, roll into balls and shape into mochi rings.",
    "Fry on medium heat for 4–5 minutes, turning frequently.",
    "Drain excess oil and cool slightly.",
    "Cook blueberries with sugar and lime till jammy, then blend.",
    "Mix with icing sugar to form glaze.",
    "Dip doughnuts, let set and glaze again if needed.",
    "Serve fresh.",
  ],
},
   {
    slug: "paan-bagel",
    title: "If paan was a bagel!",
    image: card4,

    meta: {
      servings: 6,
      prepTime: "50 min",
      cookTime: "70 min",
    },

    ingredients: {
      "Pink Dough": [
        "¾ cup (90 g) all purpose flour",
        "¼ tsp active dry or instant yeast",
        "½ tbsp (7 g) sugar",
        "Salt to taste (around ½ tsp)",
        "2 tbsp roasted beetroot puree",
        "2 tbsp (20–25 g) warm water",
        "1 tbsp rose or kewra water",
      ],

      "Green Dough": [
        "3 tbsp (40–45 g) warm water",
        "5 betel (paan) leaves",
        "1 tsp saunf, crushed",
        "¾ cup (90 g) all purpose flour",
        "¼ tsp active dry or instant yeast",
        "½ tbsp (7 g) sugar",
        "Salt to taste (around ½ tsp)",
      ],

      "White Dough": [
        "¾ cup (90 g) all purpose flour",
        "¼ tsp active dry or instant yeast",
        "½ tbsp (7 g) sugar",
        "Salt to taste (around ½ tsp)",
        "3 tbsp (40–45 g) warm water",
      ],

      "Fold Ins": [
        "2–3 tbsp gulkand",
        "¼ cup tutti frutti",
      ],

      "Cream Cheese": [
        "½ cup cream cheese",
        "2 tbsp gulkand",
        "2 tbsp tutti frutti",
      ],
    },

    instructions: [
      "Prep the beetroot: Roast beetroot at 180°C for 40–50 minutes and blend into a smooth purée.",
      "Make pink dough: Mix flour, yeast, sugar, salt, beetroot purée, rose/kewra water and warm water. Knead till smooth.",
      "Make green dough: Blend paan leaves with water, mix with flour, yeast, sugar, salt and saunf. Knead till smooth.",
      "Make white dough: Mix flour, yeast, sugar, salt and warm water. Knead till soft.",
      "First proof: Proof all three doughs for 90–120 minutes till doubled.",
      "Layer green, pink and white doughs. Spread gulkand and sprinkle tutti frutti.",
      "Roll tightly, coil and shape into a ball. Divide into 6 portions.",
      "Second proof: Proof dough balls for 30–40 minutes.",
      "Boil bagels: Boil 1 minute per side in water with 1 tbsp sugar.",
      "Bake at 200°C for 20–25 minutes till golden.",
      "Make cream cheese: Swirl gulkand and tutti frutti into cream cheese.",
      "Serve sliced bagels with gulkand cream cheese.",
    ],
  },

 {
  slug: "raspberry-matcha-cheesecake-cookie",
  title: "Raspberry Matcha Cheesecake Cookie",
  image: egg1, // import image at top

  meta: {
    servings: 8,
    prepTime: "15 min",
    cookTime: "15 min",
  },

  ingredients: {
    "Cookie Dough": [
      "2 tbsp melted butter",
      "2 tbsp brown sugar",
      "1 tbsp frozen raspberry",
      "2 tbsp condensed milk",
      "½ tsp vanilla extract",
      "⅓ cup all purpose flour",
      "1 tsp cornstarch",
      "⅛ tsp baking soda",
    ],

    "Fold Ins": [
      "1 tbsp frozen raspberry",
      "2 tbsp white chocolate chips",
    ],

    "Cheesecake Batter": [
      "½ cup cream cheese",
      "¼ cup + 2 tbsp fresh cream",
      "¼ cup condensed milk",
      "2 tbsp white chocolate, melted (optional)",
      "½ tsp vanilla extract (optional)",
      "1 tbsp matcha",
      "1 tsp tapioca starch or cornstarch",
    ],

    "Equipment": [
      "Airfryer",
    ],
  },

  instructions: [
    "Whisk butter, sugar, raspberry, condensed milk, vanilla till smooth.",
    "Fold in flour, cornstarch and baking soda gently.",
    "Fold in white chocolate and raspberries.",
    "Line tin with parchment, press cookie dough evenly and chill.",
    "Whisk cream cheese, vanilla and cream till smooth.",
    "Add condensed milk, white chocolate, matcha and starch. Whisk.",
    "Pour batter over cookie base, smooth top.",
    "Bake till top is burnt and centre wobbly.",
    "Oven: 220°C 13 min → 180°C 5–6 min.",
    "Airfryer: 200°C 8 min → 175°C 4–5 min.",
    "Cool completely, refrigerate 1 hour, slice with hot knife.",
  ],
},
  {
  slug: "brown-butter-chocolate-chip-cookies",
  title: "Brown Butter Chocolate Chip Cookies",
  image: egg2,

  meta: {
    servings: "7–8 cookies",
    prepTime: "20 min",
    cookTime: "10 min",
    chillTime: "60 min",
  },

  ingredients: {
    "Cookie Dough": [
      "½ cup butter",
      "⅓ cup brown sugar, powdered",
      "¼ cup white sugar, powdered",
      "2 tbsp milk",
      "½ tbsp vanilla essence",
      "1 cup all purpose flour",
      "1 tbsp cornstarch",
      "¼ tsp baking soda",
      "Pinch of salt",
    ],

    "Mix-ins": [
      "¼ cup dark chocolate chips",
      "¼ cup dark chocolate chunks",
      "¼ cup milk chocolate chips",
    ],

    "Garnish": [
      "Flaky sea salt",
    ],
  },

  instructions: [
    "Brown butter on low heat till golden. Cool 5–10 min.",
    "Whisk sugars with butter till glossy.",
    "Add milk and vanilla.",
    "Fold in flour, cornstarch and baking soda.",
    "Fold in chocolates gently.",
    "Scoop dough balls and chill 1 hour.",
    "Bake till edges set, centre gooey.",
    "Oven: 180°C 8–10 min.",
    "Airfryer: 170°C 7–10 min.",
    "Sprinkle flaky salt and enjoy.",
  ],
},
  {
  slug: "90-second-microwave-cookie",
  title: "90 Second Microwave Chocolate Cookie",
  image: egg3,

  meta: {
    servings: 1,
    prepTime: "10 min",
    cookTime: "90 sec",
  },

  ingredients: {
    "Cookie": [
      "1 tbsp melted butter",
      "1 tsp milk",
      "1 tbsp powdered brown sugar",
      "Few drops vanilla",
      "3 tbsp all purpose flour",
      "Pinch baking soda (1/16 tsp)",
      "1 tbsp dark chocolate chips",
      "1 tbsp dark chocolate chunks",
    ],

    "Optional": [
      "Flaky sea salt",
    ],
  },

  instructions: [
    "Mix butter, milk, sugar and vanilla till smooth.",
    "Add flour and baking soda, mix gently.",
    "Fold in chocolate chips and chunks.",
    "Shape cookie on parchment paper.",
    "Freeze 5 minutes.",
    "Microwave at low power for 90–120 sec.",
    "Let cool completely before eating.",
    "Finish with flaky salt.",
  ],
}
,
 {
  slug: "tiramisu-cheesecake-cookie-skillet",
  title: "Tiramisu Cheesecake Cookie Skillet",
  image: egg4,

  meta: {
    servings: "6 slices",
    prepTime: "20 min",
    cookTime: "15 min",
  },

  ingredients: {
    "Cookie Dough": [
      "2 tbsp melted butter",
      "2 tbsp brown sugar",
      "2 tbsp condensed milk",
      "½ tbsp instant coffee powder",
      "½ tsp vanilla extract",
      "⅓ cup all purpose flour",
      "1 tsp cornstarch",
      "⅛ tsp baking soda",
      "2 tbsp milk + dark chocolate chips",
    ],

    "Cheesecake Batter": [
      "¼ cup cream cheese",
      "¼ cup mascarpone cheese",
      "¼ cup + 2 tbsp fresh cream",
      "¼ cup condensed milk",
      "½ tsp vanilla extract",
      "2 tbsp melted white chocolate",
      "1 tsp tapioca starch",
    ],

    "Whipped Mascarpone Cream": [
      "¼ cup mascarpone",
      "⅓ cup whipping cream",
      "1½ tbsp icing sugar",
      "2 tbsp whiskey (optional)",
      "½ tsp vanilla",
      "Cocoa powder for dusting",
    ],
  },

  instructions: [
    "Mix cookie dough ingredients and press into skillet.",
    "Chill while preparing cheesecake batter.",
    "Whisk cheeses, cream, vanilla till smooth.",
    "Add condensed milk, white chocolate and starch.",
    "Pour batter over cookie base.",
    "Bake till burnt top and wobbly centre.",
    "Cool completely and refrigerate.",
    "Whip cream with sugar, mix with mascarpone.",
    "Pipe cream, dust cocoa and slice.",
  ],
}
,
{
  slug: "kadhai-chocolate-chip-cookie",
  title: "Kadhai Chocolate Chip Cookie",
  image: card11,

  meta: {
    servings: 1,
    prepTime: "7 min",
    cookTime: "13 min",
  },

  ingredients: {
    "Cookie Dough": [
      "1 tbsp butter, melted",
      "1 tbsp brown sugar",
      "½ tbsp powdered white sugar",
      "¾ tbsp milk",
      "½ tsp vanilla essence",
      "3 tbsp all purpose flour",
      "½ tsp cornstarch",
      "1/16 tsp baking soda",
    ],
    "Mix-ins + Toppings": [
      "1 tbsp dark chocolate chips",
      "1 tbsp dark chocolate callets",
      "Flaky sea salt",
    ],
  },

  instructions: [
    "Preheat a kadhai with a thick layer of salt and a plate on top for 7 minutes.",
    "Whisk sugars, milk, vanilla and melted butter.",
    "Sift flour, cornstarch and baking soda. Mix gently.",
    "Fold in chocolate chips and callets.",
    "Scoop dough onto parchment and add extra chocolate.",
    "Place on preheated plate, cover and cook on low for 13–15 minutes.",
    "Sprinkle flaky salt and cool slightly before serving.",
  ],
}
,
{
  slug: "nutella-cheesecake-cookie",
  title: "Nutella Cheesecake Cookie",
  image: card21,

  meta: {
    servings: 6,
    prepTime: "15 min",
    cookTime: "20 min",
  },

  ingredients: {
    "Cookie Dough": [
      "2 tbsp melted butter",
      "2 tbsp brown sugar",
      "2 tbsp condensed milk",
      "½ tsp vanilla extract",
      "⅓ cup all purpose flour",
      "1 tsp cornstarch",
      "⅛ tsp baking soda",
      "3 tbsp chocolate chips",
    ],
    "Cheesecake Batter": [
      "½ cup cream cheese",
      "¼ cup + 2 tbsp fresh cream",
      "¼ cup condensed milk",
      "½ tsp vanilla extract",
      "1 tsp tapioca starch",
    ],
    "Nutella Ganache": [
      "2 tbsp Nutella",
      "¼ cup fresh cream",
    ],
  },

  instructions: [
    "Mix cookie dough ingredients and press into lined skillet.",
    "Chill while preparing cheesecake batter.",
    "Whisk cream cheese, cream and vanilla till smooth.",
    "Add condensed milk and starch, mix well.",
    "Pour batter over cookie base.",
    "Bake till burnt top and wobbly centre.",
    "Prepare ganache by heating Nutella with cream.",
    "Pour ganache over cheesecake, finish with flaky salt.",
  ],
}
,
{
  slug: "mango-crepe-parcels",
  title: "Mango Crepe Parcels",
  image: card31,

  meta: {
    servings: 6,
    prepTime: "20 min",
    cookTime: "15 min",
  },

  ingredients: {
    "Crepe Batter": [
      "¾ cup milk",
      "½ cup all purpose flour",
      "1 tbsp tapioca starch",
      "1 tbsp powdered sugar",
      "1 tbsp melted butter",
      "½ tsp vanilla extract",
    ],
    "Whipped Cream": [
      "1 cup whipping cream",
      "2 tbsp icing sugar",
      "2 tbsp condensed milk",
      "¼ tsp vanilla extract",
    ],
    "Fruit": [
      "2 ripe mangoes",
    ],
  },

  instructions: [
    "Blend beetroot with milk (optional) and strain.",
    "Mix batter ingredients and strain again.",
    "Cook crepes on low heat on one side only.",
    "Whip cream with sugar, condensed milk and vanilla.",
    "Slice mangoes evenly.",
    "Fill crepes with cream and mango and wrap like parcels.",
    "Chill briefly and serve cold.",
  ],
}
,
{
  slug: "nutella-lava-cookie",
  title: "Nutella Lava Cookie",
  image: card41,

  meta: {
    servings: 1,
    prepTime: "5 min",
    cookTime: "10 min",
  },

  ingredients: {
    "Cookie Batter": [
      "2 tbsp dark chocolate chips",
      "1 tbsp butter",
      "2 tbsp condensed milk",
      "⅛ tsp vanilla extract",
      "Pinch instant coffee",
      "2½ tbsp all purpose flour",
      "1/16 tsp baking soda",
      "3 chopped walnuts (optional)",
    ],
    "Stuffing": [
      "1 tbsp frozen Nutella",
    ],
    "Topping": [
      "Flaky salt",
    ],
  },

  instructions: [
    "Melt chocolate and butter in microwave.",
    "Whisk till smooth, add condensed milk and vanilla.",
    "Add flour and baking soda, mix gently.",
    "Line ramekin, add batter, Nutella center, cover.",
    "Bake till edges set and centre gooey.",
    "Sprinkle flaky salt and serve warm.",
  ],
}
,
];
